// Coverage canvases in output space: one per placement from its lit surfaces; cut surfaces punch every one. Alpha is coverage.
import { placements } from './placement'

const MAX_SIDE = 2048

export const maskScale = ({ width, height }) => Math.min(1, MAX_SIDE / Math.max(width, height))

export const buildMasks = (data, doc = document) => {
	const scale = maskScale(data.output)
	const W = Math.max(1, Math.round(data.output.width * scale))
	const H = Math.max(1, Math.round(data.output.height * scale))
	const make = () => Object.assign(doc.createElement('canvas'), { width: W, height: H })
	const temp = make()
	const t = temp.getContext('2d')

	const draw = (target, s, op) => {
		let path
		try {
			path = new Path2D(s.path)
		} catch {
			return
		}
		t.setTransform(1, 0, 0, 1, 0, 0)
		t.globalCompositeOperation = 'source-over'
		t.clearRect(0, 0, W, H)
		t.setTransform(scale, 0, 0, scale, 0, 0)
		t.fillStyle = t.strokeStyle = '#fff'
		t.lineJoin = 'round'
		t.fill(path, 'evenodd')
		if (s.offset) {
			t.lineWidth = 2 * Math.abs(s.offset)
			if (s.offset < 0) t.globalCompositeOperation = 'destination-out'
			t.stroke(path)
		}
		const ctx = target.getContext('2d')
		ctx.globalCompositeOperation = op
		ctx.filter = s.feather > 0 ? `blur(${(s.feather * scale) / 2}px)` : 'none'
		ctx.drawImage(temp, 0, 0)
		ctx.filter = 'none'
		ctx.globalCompositeOperation = 'source-over'
	}

	const slices = {}
	for (const p of placements(data)) {
		slices[p.key] = make()
		for (const s of p.surfaces) draw(slices[p.key], s, 'source-over')
	}
	for (const s of Object.values(data.surfaces)) {
		if (s.hidden || s.role !== 'cut') continue
		for (const target of Object.values(slices)) draw(target, s, 'destination-out')
	}
	return { slices }
}
